import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/creatives", label: "Creatives" },
  { to: "/about", label: "About Us" },
  { to: "/blogs", label: "Blogs" },
  { to: "/contact", label: "Contact Us" },
];

const NavItem = ({ to, label }) => (
  <NavLink
    to={to}
    end={to === "/"}
    data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}-link`}
    className={({ isActive }) =>
      `nav-link relative text-sm uppercase tracking-[0.2em] font-medium ${
        isActive ? "text-ahm-orange" : "text-ahm-teal"
      }`
    }
  >
    <span className="orig block">{label}</span>
    <span className="dup">{label}</span>
  </NavLink>
);

const Header = () => {
  const { config } = useSite();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img
            src={config.logo_url}
            alt="AHM"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavItem key={l.to} {...l} />
          ))}
        </nav>
        <Link to="/contact" className="hidden md:inline-flex btn-pill text-sm" data-testid="nav-cta-button">
          Let's talk
          <span className="rotate-[30deg] inline-block">→</span>
        </Link>
        <Link to="/contact" className="md:hidden text-ahm-teal text-sm font-semibold underline">
          Contact
        </Link>
      </div>
    </header>
  );
};

export default Header;
